import React from 'react';
import { Box, Typography } from '@mui/material';

function RegisterPage() {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh">
      <Typography variant="h4">Registration Page - Coming Soon</Typography>
    </Box>
  );
}

export default RegisterPage;
